import axios from 'axios';

export async function fetchAllEvents() {
  const options = {
    method: 'POST',
    url: 'https://graphql.umbraco.io',
    headers: {
      'content-type': 'application/json',
      'Umb-Project-Alias': process.env.GATSBY_UMBRACO_ENVIRONMENT,
      'Api-Key': process.env.GATSBY_PREVIEW_API_KEY,
    },
    data: {
      query: `
      query {
        allDswEvent(orderBy: startDate_ASC) {
          items {
            title
            subtitle
            description
            featuredImage {
              url
            }
            url
            startDate
            endDate
            videoUrl
            registerLink {
              name
              url
              target
            }
            dswSportsCategory
            dswFitnessTypes
            dswEventType
            isActiveFun
            hideDate
            eventContactName
            eventContactEmail
            eventContactPhone
            eventWebsite
            metadataTitle
            metadataDescription
            metadataKeywords
            socialMediaImage {
              url
            }
          }
        }
      }
    `,
    },
  };

  const data = await axios.request(options);
  return data?.data?.data?.allDswEvent?.items || [];
}
